import React, { useState } from 'react';
import { automationsApi } from '../../services/endpoints';
import { useApiData, StateBlock } from './useApiData';

export default function Automations() {
  const { data: automations, loading, error, reload } = useApiData(() => automationsApi.list());
  const [busyId, setBusyId] = useState(null);

  const handleToggle = async (id) => {
    setBusyId(id);
    try {
      await automationsApi.toggle(id);
      await reload();
    } finally {
      setBusyId(null);
    }
  };

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Automations</h1>
      <StateBlock loading={loading} error={error} onRetry={reload} isEmpty={automations?.length === 0} emptyLabel="No automations yet.">
        <div className="space-y-3">
          {automations?.map((a) => (
            <div key={a.id} className="glass rounded-xl p-4 flex items-center justify-between">
              <div>
                <p className="font-medium">{a.name}</p>
                {a.description && <p className="text-white/40 text-xs mt-0.5">{a.description}</p>}
              </div>
              <button
                onClick={() => handleToggle(a.id)}
                disabled={busyId === a.id}
                className={`text-xs px-3 py-1.5 rounded-full transition-colors disabled:opacity-50 ${
                  a.is_enabled ? 'bg-green-500/20 text-green-400' : 'bg-white/10 text-white/40'
                }`}
              >
                {a.is_enabled ? 'Enabled' : 'Disabled'}
              </button>
            </div>
          ))}
        </div>
      </StateBlock>
    </div>
  );
}
